import React, { useEffect, useState } from 'react';
import { Header } from '../../components';
import Layout from '../layout/Layout';
import { Link, useParams } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase/firebase-config';
import { convertDate } from '../../utils/date';
import { BiPhone } from 'react-icons/bi';
import { MdModeEditOutline } from 'react-icons/md';

import TabPanel, { a11yProps } from '../../components/TabPanel';
import Modal from "../../components/Modal";
import { Box, Tab, Tabs } from '@mui/material';
// import UserAlerts from './alerts';
import UserTransactions from "./transactions"
import { fetchUserDetails, updateUser } from '../../services/users';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditUserForm from './edit-user-form';
import BeatLoader from 'react-spinners/BeatLoader';
import Constant from '../../Constant';
import SkeletonWrapper from './User.skeleton';
import { BsCheck2, BsEyeFill, BsX, BsXCircle } from 'react-icons/bs';
import IpWhitelistModal from '../../components/forms/IpWhitelistForm/IpWhitelistModal';
import MerchantLedgerSection from './MerchantLedgerSection';
import MerchantFeeSection from './MerchantFeeSection';
import MerchantKybModal from './MerchantKybModal';

/**-
 * 
 * @param {string} _range 
 */
let interpreteAgeRange = _range => {
  let tab = _range.split(",");
  return tab[0] + " to " + tab[1] + " years old";
};

const UsersDetails = () => {
  const { userId } = useParams();
  const [user] = useAuthState(auth);
  const [tabValue, setTabValue] = React.useState(0);
  const [userDetails, setUserDetails] = useState(null);
  const [refresh, setRefresh] = React.useState(false);
  const [inprogress, setInprogress] = React.useState(false);
  const [loadingSkeleton, setLoadingSkeleton] = React.useState(true);
  const [authToken, setAuthToken] = useState("");

  const modalViewRef = React.useRef(null);
  const editFormUpdateRef = React.useRef(null);
  const ipModalRef = React.useRef(null);
  const kybModalRef = React.useRef(null);

  const getUserDetails = (token) => {
    setInprogress(true)
    fetchUserDetails(userId, token)
      .then(res => {
        if (res.status_code == 200) {
          console.log('user', res.data.user);
          toast.success(`${res.message}`);
          setUserDetails(res.data.user);
        } else {
          toast.error(`${res.message}`);
        }
      }).catch(err => {
        toast.error(`${err}`);
      }).finally(() => {
        setInprogress(false);
        setLoadingSkeleton(false);
      });
  }

  const getBalanceAndCurrency = () => (userDetails?.wallet.balance ?? 0) + " " + (userDetails?.wallet.currency ?? "");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const openDetailsModal = () => {
    modalViewRef.current.open();
  }

  const closeDetailsModal = () => {
    modalViewRef.current.close();
    editFormUpdateRef.current.clearVals();
  }

  const updateUserInfo = () => {
    const update = editFormUpdateRef.current.getValues();

    if (!update) return closeDetailsModal();

    setInprogress(true)
    updateUser(userDetails.id, update, authToken)
      .then(result => {
        if (result.status_code === 200) {
          toast(`${result.message}`);
          setRefresh(prev => !prev);
        } else {
          toast.error(`${result.message}`);
        }
      }).catch(err => {
        toast(`Sorry, we could not update this user. Please try again`);

      }).finally(() => {
        setInprogress(false);
      });

    closeDetailsModal();
  }

  useEffect(() => {
    setTabValue(0);
  }, [userId]);

  useEffect(() => {
    if (userDetails?.role?.name !== "MERCHANT" && tabValue > 0) {
      setTabValue(0);
    }
  }, [userDetails, tabValue]);

  useEffect(() => {
    user.getIdToken(true).then(token => {
      // console.log(`Auth Token ${token}`);
      setAuthToken(token);
      getUserDetails(token);
    })
  }, [refresh]);

  return (
    <Layout>
      <div className="m-2 md:m-10 mt-24 s rounded-[10px]">
        <Header category="Users Details" title="" />
        <div className="grid grid-cols-1 md:grid-cols-6 gap-[20px]">
          <div className="col-span-4 md:col-span-2">
            <SkeletonWrapper loading={loadingSkeleton}>
              <div className="rounded py-2 bg-[#fff]">
                <div className="bg-[#343A3F] h-[135px] flex flex-col items-center py-5">
                  <div className="right text-center mb-[4px]">
                    <p className="text-[#fff]">{userDetails?.username ?? "Username"}</p>
                    <p className="text-[#fff] text-sm">{userDetails?.email ? userDetails?.email : "No Email"}</p>
                  </div>
                  <div className="left flex-initial">
                    <img className="object-contain rounded-full h-28 w-26" src={userDetails?.image_avatar ?? require('../../images/avatar.png')} />
                  </div>
                </div>

                <div className="flex mt-[60px] justify-center items-center">
                  <BiPhone size={20} />
                  <p className="text-md ml-[4px]"> {userDetails?.phone_number}</p>
                </div>
                <div className="grid grid-cols-6 my-4">
                  <div className="col-span-2 text-center">
                    <p className="text-md font-semibold">{userDetails?.role.name}</p>
                    <p className="text-sm mt-2">Role</p>
                  </div>
                  <div className="col-span-2 text-center">
                    <p className="text-md font-semibold">{userDetails?.isActive ? 'Active' : "InActive"}</p>
                    <p className="text-sm mt-2">Status</p>
                  </div>
                  <div className="col-span-2 text-center whitespace-normal">
                    <p className="text-md font-semibold">{convertDate(userDetails?.created_at)}</p> {/* TODO: fix createdAt.seconds. recieving "created_at" as time */}
                    <p className="text-sm mt-2">Created At</p>
                  </div>
                </div>
              </div>
            </SkeletonWrapper>
          </div>

          <div className="col-span-4">
            <SkeletonWrapper loading={loadingSkeleton}>
              <div className="py-2 bg-[#fff] rounded-[8px] p-3 h-full">
                <div className='flex items-center justify-between'>
                  <p className='font-semibold'>About</p>

                  {userDetails && (
                    <div className="flex items-center gap-2">
                      {userDetails?.role?.name === "MERCHANT" && (
                        <button
                          className="bg-[#405B9C] rounded-full text-[#fff] px-3 py-2 text-sm"
                          onClick={() => ipModalRef.current.open(userDetails.id)}
                        >
                          Allowed IPs
                        </button>
                      )}
                      <button
                        className="bg-[#343A3F] rounded-full text-[#000] p-2"
                        onClick={openDetailsModal}
                      >
                        <MdModeEditOutline size={16} color="#fff" />
                      </button>
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-12 mt-10 gap-4">
                  <div className="col-span-4">
                    <p>Name</p>
                    <p className="text-[#919aa3]">{(userDetails?.first_name ?? "") + ' ' + (userDetails?.last_name ?? "")}</p>
                    <br/>
                    <p>Email</p>
                    <p className="text-[#919aa3]">{(userDetails?.email ?? "")}</p>
                    <br/>
                    <p>Phone</p>
                    <p className="text-[#919aa3]">{(userDetails?.phone_number ?? "")}</p>
                  </div>
                  <div className="col-span-4">
                    <p>Address</p>
                    <p className="text-[#919aa3]">{userDetails?.address.address ?? "Not available"}</p>
                    <br/>
                    <p>City</p>
                    <p className="text-[#919aa3]">{userDetails?.address.city ?? "Not available"}</p>
                    <br/>
                    <p>Country ({userDetails?.address?.country?.code ?? "Not available"})</p>
                    <p className="text-[#919aa3]">{userDetails?.address.country?.name ?? "Not available"}</p>
                  </div>
                  <div className="col-span-4">
                    <p>Postal Code</p>
                    <p className="text-[#919aa3]">{userDetails?.address?.postal_code ?? "_ _ _ "}</p>
                    <br/>
                    <p>Language</p>
                    <p className="text-[#919aa3]">{userDetails?.language ?? "Not available"}</p>
                    <br/>
                    <p>Balance</p>
                    <p className="text-[#919aa3]">{getBalanceAndCurrency() ?? "Not available"}EUR</p>
                  </div>
                  <div className="col-span-12">
                    <table>
                      <thead></thead>
                      <tbody>
                        <tr>
                          <td className='font-bold'>KYC</td>
                          <td>
                            <p className="text-[#919aa3]">&nbsp;Personal ID </p>                 
                          </td>
                          <td>
                            {
                              userDetails?.personal_id?.pid_doc &&
                              <BsCheck2 style={{ color: '#0b0',}} size={20} />
                            }
                            {
                              userDetails?.personal_id?.pid_doc === null && 
                              <BsX style={{ color: '#e00',}} size={25} />
                            }
                          </td>
                          <td>
                            <p className="text-[#919aa3]">
                              {
                                userDetails?.personal_id?.pid_doc &&
                                <Link to={userDetails?.personal_id?.pid_doc}>
                                  <BsEyeFill size={20}/>
                                </Link>}
                            </p>       
                          </td>
                          <td>
                            <p className="text-[#919aa3]">&nbsp;Selfie </p>                 
                          </td>
                          <td>
                            &nbsp;
                            {
                              userDetails?.personal_id?.selfie_image && 
                              <BsCheck2 style={{ color: '#0b0',}} size={20} />
                            }
                            {
                              userDetails?.personal_id?.selfie_image === null && 
                              <BsX style={{ color: '#e00',}} size={25} />
                            } &nbsp;
                          </td>
                          <td>
                            <p className="text-[#919aa3]">
                              {
                                userDetails?.personal_id?.selfie_image &&
                                <Link to={userDetails?.personal_id?.selfie_image}>
                                  <BsEyeFill/>
                                </Link>
                              }
                            </p>                 
                          </td>
                          <td>
                            <p className="text-[#919aa3]">Address Doc </p>                 
                          </td>
                          <td>
                          &nbsp;
                            {
                              userDetails?.address?.poa && 
                              <BsCheck2 style={{ color: '#0b0',}} size={20} />
                            }
                            {
                              userDetails?.address?.poa === null && 
                              <BsX style={{ color: '#e00',}} size={25} />
                            } &nbsp;
                          </td>
                          <td>
                            <p className="text-[#919aa3]">
                              {
                                userDetails?.address?.poa && 
                                <Link to={userDetails?.address?.poa}>
                                  <BsEyeFill/>
                                </Link>
                              }
                            </p>                 
                          </td>
                          <td>
                            <p className="text-[#919aa3]"> Professional Doc </p>                 
                          </td>
                          <td>
                          &nbsp;
                            {
                              userDetails?.profession && 
                              <BsCheck2 style={{ color: '#0b0',}} size={20} />
                            }
                            {
                              userDetails?.profession === null && 
                              <BsX style={{ color: '#e00',}} size={25} />
                            } &nbsp;
                          </td>
                          <td>
                            <p className="text-[#919aa3]">
                              {
                                userDetails?.profession && 
                                <Link to={userDetails?.profession}>
                                  <BsEyeFill size={25}/>
                                </Link>
                              }
                            </p>                 
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <p className="text-[#919aa3]">{userDetails?.kyc_level ?? "Not available"}</p> */}
                    {userDetails?.role?.name === "MERCHANT" && (
                      <div className="mt-6">
                        <div className="flex items-center justify-between mb-2">
                          <p className="font-bold">KYB</p>
                          <button
                            className="bg-[#405B9C] rounded-full text-[#fff] px-3 py-1 text-sm"
                            onClick={() => kybModalRef.current.open(userDetails)}
                          >
                            Update KYB
                          </button>
                        </div>
                        <p className="text-sm text-[#767676] mb-2">
                          Status: {userDetails?.merchant_kyb?.status || "Not submitted"}
                          {userDetails?.merchant_kyb?.tax_id
                            ? ` · Tax ID ${userDetails.merchant_kyb.tax_id}`
                            : ""}
                          {userDetails?.merchant_kyb?.business_registration_number
                            ? ` · Reg ${userDetails.merchant_kyb.business_registration_number}`
                            : ""}
                        </p>
                        <p className="text-sm text-[#767676] mb-3">
                          {userDetails?.merchant_kyb?.business_registration_expiry
                            ? `Reg expiry ${new Date(userDetails.merchant_kyb.business_registration_expiry).toLocaleDateString()}`
                            : ""}
                          {userDetails?.merchant_kyb?.md_id_expiry
                            ? ` · MD ID expiry ${new Date(userDetails.merchant_kyb.md_id_expiry).toLocaleDateString()}`
                            : ""}
                          {userDetails?.merchant_kyb?.poa_document_date
                            ? ` · POA date ${new Date(userDetails.merchant_kyb.poa_document_date).toLocaleDateString()}`
                            : ""}
                        </p>
                        <table>
                          <tbody>
                            <tr>
                              <td className="text-[#919aa3] pr-2">Business registration</td>
                              <td>
                                {userDetails?.merchant_kyb?.business_registration_doc ? (
                                  <BsCheck2 style={{ color: "#0b0" }} size={20} />
                                ) : (
                                  <BsX style={{ color: "#e00" }} size={25} />
                                )}
                              </td>
                              <td>
                                {userDetails?.merchant_kyb?.business_registration_doc && (
                                  <Link to={userDetails.merchant_kyb.business_registration_doc}>
                                    <BsEyeFill size={20} />
                                  </Link>
                                )}
                              </td>
                              <td className="text-[#919aa3] px-2">MD selfie ID</td>
                              <td>
                                {userDetails?.merchant_kyb?.md_selfie_doc ? (
                                  <BsCheck2 style={{ color: "#0b0" }} size={20} />
                                ) : (
                                  <BsX style={{ color: "#e00" }} size={25} />
                                )}
                              </td>
                              <td>
                                {userDetails?.merchant_kyb?.md_selfie_doc && (
                                  <Link to={userDetails.merchant_kyb.md_selfie_doc}>
                                    <BsEyeFill size={20} />
                                  </Link>
                                )}
                              </td>
                              <td className="text-[#919aa3] px-2">Proof of address</td>
                              <td>
                                {userDetails?.merchant_kyb?.proof_of_address_doc ? (
                                  <BsCheck2 style={{ color: "#0b0" }} size={20} />
                                ) : (
                                  <BsX style={{ color: "#e00" }} size={25} />
                                )}
                              </td>
                              <td>
                                {userDetails?.merchant_kyb?.proof_of_address_doc && (
                                  <Link to={userDetails.merchant_kyb.proof_of_address_doc}>
                                    <BsEyeFill size={20} />
                                  </Link>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )}
                   
                  </div>
                </div>
              </div>
            </SkeletonWrapper>
          </div>
        </div>
        <div className='box-border'>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="basic tabs example"
                variant="fullWidth">
                {/* <Tab label="Alerts" {...a11yProps(0)}/> */}
                <Tab label="Transactions" {...a11yProps(0)} />
                {userDetails?.role?.name === "MERCHANT" && (
                  <Tab label="Debit / Credit" {...a11yProps(1)} />
                )}
                {userDetails?.role?.name === "MERCHANT" && (
                  <Tab label="Fee rates" {...a11yProps(2)} />
                )}
              </Tabs>
            </Box>
          </Box>
          {/* <TabPanel value={tabValue} index={0}>
          <UserAlerts userId={userId}/>
          </TabPanel> */}
          <TabPanel value={tabValue} index={0}>
            <UserTransactions
              key={userId}
              userId={userId}
              authToken={authToken}
              refreshKey={refresh}
            />
          </TabPanel>
          {userDetails?.role?.name === "MERCHANT" && (
            <>
              <TabPanel value={tabValue} index={1}>
                <MerchantLedgerSection
                  userId={userDetails.id}
                  authToken={authToken}
                  onAdjusted={() => setRefresh((prev) => !prev)}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={2}>
                <MerchantFeeSection
                  merchantUserId={userDetails.user_id}
                  authToken={authToken}
                />
              </TabPanel>
            </>
          )}
        </div>

        <Modal
          title="Update User"
          onSubmit={updateUserInfo}
          onClose={() => null}
          ref={modalViewRef}
          submitBtn='Save'
          cancelBtn='Close'
        >
          <EditUserForm
            ref={editFormUpdateRef}
            data={userDetails}
          />
          <BeatLoader
            color={Constant.spinner_color}
            loading={inprogress}
            className="__center_spinner"
            cssOverride={{
              textAlign: 'center',
              marginTop: '20px'
            }}
          />
        </Modal>
        <IpWhitelistModal ref={ipModalRef} authToken={authToken} />
        <MerchantKybModal
          ref={kybModalRef}
          authToken={authToken}
          onSaved={() => setRefresh((prev) => !prev)}
        />
      </div>
    </Layout>
  );
};

export default UsersDetails;
